const tablet = 768;
const desktop = 1024;

module.exports = {
    tablet, desktop
};
